import { RegistrationFormData } from "@/app/types/user";
import { apiSlice } from "@/features/api/ApiSlice";
import { TicketAction } from "./LiveQueueService";
import { Gender } from "@/app/shared_enums/enums";
import { CountryTypes } from "@/app/types/shared_types";
const { VITE_ORG_ID } = import.meta.env;

interface UserValidation {
  user_id: number;
}
interface ValidationResponse {
  user_id: number;
  status: string;
  notes: string;
  created_at: string;
}
export const Transaction = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getValidateUser: builder.query<ValidationResponse, UserValidation>({
        query: (userdata) => ({
          url: `/user/${userdata.user_id}/validate?user_type=staff`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["User"],
      }),
      registerUser: builder.mutation<
        RegistrationFormData,
        RegistrationFormData
      >({
        query: (data) => ({
          url: `/customers/edit_customer/${data.id}`,
          method: "PUT",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["User"],
      }),
      getUserById: builder.query<RegistrationFormData, number>({
        query: (id) => ({
          url: `/customers/${id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["User"],
      }),
      getUserByUsername: builder.query<
        RegistrationFormData[],
        { username: string }
      >({
        query: ({ username }) => ({
          url: `/live-queue/users/search?username=${username}&org_id=${VITE_ORG_ID}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
      }),

      saveUserAgainstTicket: builder.mutation<
        {
          success: boolean;
          message: string;
        },
        {
          ticket_id: number;
          staff_id: string;
          action: TicketAction;
          user_data: {
            username: string;
            email: string;
            phone_num: string;
            first_name: string;
            last_name: string;
            gender: Gender;
          };
        }
      >({
        query: (data) => ({
          url: `/live-queue/tickets/${data.ticket_id}/action?staff_id=${data.staff_id}`,
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: data,
        }),
        invalidatesTags: ["LiveQueue"],
      }),
      getCountries: builder.query<CountryTypes[], void>({
        query: () => `/customers/countries/list`,
        transformResponse: (response: {
          data: CountryTypes[];
          total_count: number;
        }) => response.data,
      }),

      deleteSessions: builder.mutation<
        void,
        {
          user_id: number;
          fcm_token: string;
        }
      >({
        query: ({ user_id, fcm_token }) => ({
          url: `/user_sessions/delete/`,
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: {
            user_id:user_id,
            fcm_token:fcm_token
          },
        }),
      }),
    };
  },
});

export const {
  useGetValidateUserQuery,
  useRegisterUserMutation,
  useGetUserByIdQuery,
  useLazyGetUserByUsernameQuery,
  useSaveUserAgainstTicketMutation,
  useGetCountriesQuery,
  useDeleteSessionsMutation
} = Transaction;
